<template>
    <div class="svg" :style="style">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" :width="length" :height="length">
            <circle :cx="cy" :cy="cy" :r="r" :stroke-width="width" :stroke="defualtColor" fill="none"></circle>
            <circle :cx="cy" :cy="cy" :r="r" :stroke-width="width" :stroke="activeColor" fill="none" :transform="transform" :stroke-dasharray="dasharray"></circle>
        </svg>
        <div style="position:absolute;display:flex;flex-direction:column;justify-content:center;" :style="text_box">
            <div style="flex-grow:3;display:flex;align-items:center;width:100%;justify-content:center;font-weght:400;font-size:14px;">领先</div>
            <div style="flex-grow:4;display:flex;align-items:center;width:100%;justify-content:center;font-weght:700;font-size:18px;color:#2daa51;">{{rate_text}}</div>
            <div style="flex-grow:3;display:flex;align-items:center;width:100%;justify-content:center;font-weght:400;font-size:14px;">{{category === 1 ? '用户' : '求职者'}}</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        length: { // 边长
            type: Number,
            default: 120
        },
        width: { // 圆环宽度
            type: Number,
            default: 10
        },
        rate: { // 大小
            type: Number,
            default: 0
        },
        defualtColor: { // 默认颜色
            type: String,
            default: '#D1D3D7'
        },
        activeColor: { // 活动部分颜色
            type: String,
            default: '#00A5E0'
        },
        category: { // 活动部分颜色
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            'rate_text': '',
            'transform': 'matrix(0,-1,1,0,0,120)',
            'dasharray': '0 0',
            'cf': 0,// 周长
            'cx': 0,
            'cy': 0,
            'r': 0,
            'style': 'width:0px;height:0px;',
            'text_box': ''
        }
    },
    created: function () {
        let that = this
        that.transform = `matrix(0,-1,1,0,0,${that.length})`
        that.cx = that.length / 2
        that.cy = that.length / 2
        that.r = that.length / 2 - that.width
        that.cf = 2 * Math.PI * that.r
        that.dasharray = `${that.cf * that.rate}  ${that.cf * (1 - that.rate)}`
        that.rate_text = (that.rate * 100).toFixed(2) + '%'
        that.style = `width: ${that.length}px; height: ${that.length}px;`
        let h = that.length - that.width * 4;
        that.text_box = `width:${h}px; height: ${h}px;left:${that.width * 2}px;top:${that.width * 2}px;`
    }
}
</script>
<style lang="less" scoped>
.svg {
    position: relative;
}
</style>



// WEBPACK FOOTER //
// svg-circle.vue?05e512d9